import { useContext } from "react"
import RenderDifferentComponentContext from "../contexts/RenderDifferentComponentContext"

const UseRenderDifferentComponent = () => {
    return useContext(RenderDifferentComponentContext);
}

export default UseRenderDifferentComponent